import React from 'react';
import { Checkbox, Grid, Typography } from '@mui/material';

import { IQuestionDetailAnswer } from '../../../../../store/QuestionSlice';

export interface IReadOnlyAnswerOption {
  itemIndex: number;
  answer: IQuestionDetailAnswer;
}

const ReadOnlyAnswerOption: React.FC<IReadOnlyAnswerOption> = ({
  itemIndex,
  answer,
}) => {
  // DECLARATIONS
  const _optionName = `Option ${(itemIndex + 1).toString().padStart(2, '0')}`;

  // RENDER
  return (
    <Grid container spacing={2} alignItems="center">
      <Grid item xs={12} sm={4} md={4} lg={3}>
        <Typography variant="caption" sx={{ mr: '5px' }}>
          {_optionName}
        </Typography>
        <Checkbox
          sx={{ transform: 'scale(1.2)' }}
          color="success"
          checked={answer.isCorrect}
        />
      </Grid>
      <Grid item xs={12} sm={8} md={8} lg={9}>
        <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
          <div
            className="view ql-editor ql-viewer"
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{ __html: answer.content }}
          />
        </div>
      </Grid>
    </Grid>
  );
};

export default ReadOnlyAnswerOption;
